import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-md shadow-md bg-white overflow-hidden animate-pulse relative"
}
const _hoisted_2 = { class: "min-w-[13rem] w-full min-h-[13rem] aspect-square bg-gray-700" }
const _hoisted_3 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "justify-center items-center flex h-7 rounded-md px-2 py-1" }
const _hoisted_6 = { class: "text-center text-ellipsis whitespace-nowrap overflow-hidden text-white" }
const _hoisted_7 = {
  key: 2,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute right-1 top-1"
}

import { ref, watch, onBeforeMount } from 'vue';
import { StarFilled } from '@ant-design/icons-vue';
import { JAV } from '@/model/jav';

const imagePlaceholder =
	'https://www.signfix.com.au/wp-content/uploads/2017/09/placeholder-600x400.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'JAVCard',
  props: {
    jav: {}
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;



onBeforeMount(async () => (url.value = props.jav.coverImageURL));

const url = ref('');
const isLoading = ref(true);


watch(
	() => props.jav.coverImageURL,
	(imageURL) => (url.value = imageURL)
);

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "hover:brightness-75 ease-in duration-100 rounded-md min-w-[13rem] bg-black relative cursor-pointer",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('click', _ctx.jav)))
  }, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_spin, {
                tip: "Loading...",
                size: "large",
                class: "animate-pulse"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (url.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          alt: "",
          src: url.value,
          onLoad: _cache[0] || (_cache[0] = () => (isLoading.value = false)),
          onError: _cache[1] || (_cache[1] = 
				() => {
					isLoading.value = false;
					url.value = imagePlaceholder;
				}
			),
          class: _normalizeClass(
				(isLoading.value
					? 'absolute w-0 h-0 opacity-0'
					: 'min-w-[13rem] min-h-[13rem] w-full aspect-square shadow-md') +
				' object-cover rounded-md '
			),
          loading: "lazy",
          referrerPolicy: "no-referrer"
        }, null, 42, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.jav.code), 1)
    ]),
    (_ctx.jav.isFavorite && !isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(StarFilled))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})